module.exports = __webpack_public_path__ + "static/media/rigt-arrow.cb926471.svg";